<template>
  <div class="welfare-activity">
    <van-popup v-model="showDialog">
      <div class="content">
        <img
          class="header-img"
          src="../../../assets/images/dialog/welfare-dialog-headback.png"
          alt=""
          srcset=""
        >
        <img class="close-img" @click="closeDialog" src="../../../assets/images/dialog/close-icon.png" alt="" srcset="">
        <div class="title">限时充值5.8折</div>
        <div class="message">（老用户专享）</div>
        <div class="btn" @click="goDetail">去看看</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
import { setItem, getItem } from '@/utils'
import { wxNavigateTo } from '@/utils/WeChatUtil'
export default {
  props: {
  },
  data () {
    return {
      showDialog: false,
    }
  },
  computed: {
    ...mapState({
      can_recall: 'can_recall',
      dialog_index: 'vip_home_dialog_index'
    }),
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    ...mapMutations({
      updateDialogIndex: 'updateStateData'
    }),
    init() {
      this.showDialog = moment().format('YYYY-MM-DD') !== getItem('welfareDate')
        && this.can_recall && this.isAndroid // 是否显示召回活动弹框
      if (this.showDialog) {
        setItem('welfareDate', moment().format('YYYY-MM-DD'))
        return
      }
      let { dialog_index } = this
      dialog_index++
      this.updateDialogIndex({
        key: 'vip_home_dialog_index',
        value: dialog_index
      })
    },
    /**
     *
     *
     *
     * 显示弹框
    */
    showPopup () {
      this.showDialog = true
    },
    /**
     *
     *
     *
     * 去微信的活动页面
    */
    goDetail () {
      this.showDialog = false
      wxNavigateTo('/pages/activity/welfareDiscount/index')
    },
    /**
     *
     *
     *
     * 关闭弹框
    */
    closeDialog () {
      this.showDialog = false
      this.$emit('close')
    },
  }
}
</script>

<style scoped lang="scss">
.welfare-activity>:first-child {
  background-color: rgba(0,0,0,.4)
}
.welfare-activity>:last-child {
  border-radius: 20px;
  width: 80%;
}
.welfare-activity .content {
  border-radius: 30px;
  position: relative;                                                                              ;
  .header-img {
    width: 100%;
  }
  .title,.message {
    text-align: center;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    padding-top: 20px;
  }
  .message {
    font-size: 24px;
    color: #282828;
    padding-top: 10px;
  }
  .btn {
    background-color: #FF9807;
    text-align: center;
    margin: 30px 80px;
    padding: 20px 0;
    border-radius: 8px;
    color: #ffffff;
    font-size: 28px;
  }
  .close-img {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

</style>
